const dataRegex = /^data:image/;
const imageRegex = /\.(gif|jpe?g|tiff|png|svg)$/;
const colorRegex = /^(rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)|#[0-9a-fA-F]{6}|#[0-9a-fA-F]{3}|transparent)$/i;

export const isSrc = prop => dataRegex.test(prop) || imageRegex.test(prop);

export const isColor = prop => colorRegex.test(prop);
